import { render, staticRenderFns } from "./RevenueCutoff.vue?vue&type=template&id=a8255aaa&scoped=true"
import script from "./RevenueCutoff.vue?vue&type=script&lang=js"
export * from "./RevenueCutoff.vue?vue&type=script&lang=js"
import style0 from "./RevenueCutoff.vue?vue&type=style&index=0&id=a8255aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8255aaa",
  null
  
)

export default component.exports